import type { BookableOption } from "./bookable-option";
import { isManifestBookableOption } from "./is-manifest-bookable-option";
import { isQuantityPickerBookableOption } from "./quantity-picker-bookable-option";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isBookableOption = (item: any): item is BookableOption => {
    if (typeof item === "undefined") return false;
    return (
        isQuantityPickerBookableOption(item) || isManifestBookableOption(item)
    );
};

export { isBookableOption };
